import moment from 'moment';

const initialGoodsState = {
	goodsNo: null,
	activeTab: '',
	bannerId: '',
	mmsMsg: '',
	mmsTitle: '',
	myTmpltradio: 0,
	senderKey: '',
	profName: '',
	profSeq: null,
	templateCode: '',
	templateContent: '',
	templateId: '',
	templateTitle: '',
	templateThumbnailImg: '',
	tmpltradio: 0,
	tmpltSeq: null,
	tmpltValCnt: 0,
	valueCnt: 0,
	orderSend: [
		// {
		//     "sort": 1,
		//     "userNm": "윤석근",
		//     "mobileNo": "010-3265-1111"
		// }
	],
	/** 알림톡 발신자명 default value companyName*/
	senderNm: '',
	defaultYn: 'Y',
	templateImgUrl: '',
};

const initialState = {
	/**
	 * 상품별 주문정보
	 *
	 * @type {initialGoodsState[]}
	 */
	orderGoods: [],

	orderNm: '',
	callbackNo: '',
	sendWay: '02',
	templateTp: 'kTalkTemplateTab0',

	reservedDate: '',
	/**
	 * 발신유형
	 * N: 즉시발송
	 * Y: 일괄예약발송
	 * I: 수신자별 예약발송
	 */
	reservedYn: 'N',
	/**
	 * 알림톡 템플릿
	 * @type {'commonTemplate' | 'myTemplate'}
	 */

	/**
	 * 주문 화면에서 선택되어 노출되는(=편집중인) 상품번호
	 */
	selectedGoodsNo: undefined,

	/** 수신자 중복 허용 여부 */
	isAllowedDuplicateReceiver: true,

	/** 상품 정보 목록 */
	goodsList: [],

	/** 발송 30일 후 수신자 정보 자동 파기 동의 */
	isRequestDestoryInformation: false,

	/** 기존 구조상 api 결과 값을 직접 component에 전달 하고 싶을 때 사용 */
	responseData: {},

	/** 발신 목적 */
	purposeSending: '',
	purposeTp: '',
	defaultTemplate: null,
};

export const home = {
	namespaced: true,
	// isTmpltInit: 임시저장시 초기 템플릿 UI를 기본 템플릿으로 변경 ( PC와 UX를 맞추기 위해 사용 )
	// 단발성플래그를 사용한 이유는 pc와 모바일이 initiaize과정과 각 상품에 주문 정보를 매핑하는 로직의 차이가 있음
	state: { ...initialState, isTmpltInit: false },

	mutations: {
		INITIALIZE(state, goodsNoList) {
			state.orderGoods = goodsNoList.map(goodsNo => ({
				...initialGoodsState,
				goodsNo,
			}));
			state.orderNm = initialState.orderNm;
			state.callbackNo = initialState.callbackNo;
			state.sendWay = initialState.sendWay;
			state.reservedDate = moment().format('YYYY-MM-DD HH:00:00');
			state.reservedYn = initialState.reservedYn;
			state.selectedGoodsNo = goodsNoList?.[0];
			state.isAllowedDuplicateReceiver = initialState.isAllowedDuplicateReceiver;
			state.purposeSending = initialState.purposeSending;
			state.purposeTp = initialState.purposeSending;
		},
		SET_ORDER_GOODS(state, payload) {
			state.orderGoods = payload;
		},
		SET_ORDER_NM(state, payload) {
			state.orderNm = payload;
		},
		SET_CALLBACK_NO(state, payload) {
			state.callbackNo = payload;
		},
		SET_SEND_WAY(state, payload) {
			state.sendWay = payload;
		},
		SET_TEMPLATE_TP(state, payload) {
			state.templateTp = payload;
		},
		SET_RESERVED_DATE(state, payload) {
			state.reservedDate = payload;
		},
		SET_RESERVED_YN(state, payload) {
			state.reservedYn = payload;
		},
		SET_SELECTED_GOODS_NO(state, payload) {
			state.selectedGoodsNo = payload;
		},
		SET_IS_ALLOWED_DUPLICATE_RECEIVER(state, payload) {
			state.isAllowedDuplicateReceiver = payload;
		},
		SET_IS_REQUEST_DESTORY_INFORMATION(state, payload) {
			state.isRequestDestoryInformation = payload;
		},
		SET_GOODS_LIST(state, payload) {
			state.goodsList = payload;
		},
		SET_RESPONSE_DATA(state, data) {
			state.responseData = data;
		},
		SET_PURPOSE_SENDING(state, data) {
			state.purposeSending = data;
		},
		SET_PURPOSE_PURPOSETP(state, data) {
			state.purposeTp = data;
		},
		SET_DEFAULT_TEMPLATE(state, payload) {
			state.defaultTemplate = { ...state.defaultTemplate, ...payload };
		},
		TOGGLE_TMPLT_INIT(state) {
			state.isTmpltInit = !state.isTmpltInit;
		},
	},

	actions: {
		initialize({ commit }, goodsNoList = []) {
			commit('INITIALIZE', goodsNoList);
		},
		setOrderGoods({ commit }, payload = []) {
			commit('SET_ORDER_GOODS', payload);
		},
		setOrderNm({ commit }, payload) {
			commit('SET_ORDER_NM', payload);
		},
		setCallbackNo({ commit }, payload) {
			commit('SET_CALLBACK_NO', payload);
		},
		setSendWay({ commit }, payload) {
			commit('SET_SEND_WAY', payload);
		},
		setTemplateTp({ commit }, payload) {
			commit('SET_TEMPLATE_TP', payload);
		},
		setReservedDate({ commit }, payload) {
			commit('SET_RESERVED_DATE', payload);
		},
		setReservedYn({ commit }, payload) {
			commit('SET_RESERVED_YN', payload);
		},
		setGoods({ commit, state }, { goodsNo, payload }) {
			state.orderGoods.map(item => {
				if (item.goodsNo === goodsNo)
					return {
						...payload,
						goodsNo,
					};
				return item;
			});
			commit('SET_ORDER_GOODS', payload);
		},
		setSelectedGoodsNo({ commit }, payload) {
			commit('SET_SELECTED_GOODS_NO', payload);
			// checkCurrentGoodsStatus()
		},
		setIsAllowedDuplicateReceiver({ commit }, payload) {
			commit('SET_IS_ALLOWED_DUPLICATE_RECEIVER', payload);
		},
		setIsRequestDestoryInformation({ commit }, payload) {
			commit('SET_IS_REQUEST_DESTORY_INFORMATION', payload);
		},
		setGoodsList({ commit }, payload) {
			commit('SET_GOODS_LIST', payload);
		},
		setResponseData({ commit }, data) {
			commit('SET_RESPONSE_DATA', data);
		},
		setPurposeSending({ commit }, data) {
			commit('SET_PURPOSE_SENDING', data);
		},
		setPurposeTp({ commit }, data) {
			console.log('tracer purpose::', data);
			commit('SET_PURPOSE_PURPOSETP', data);
		},
		setDefaultTemplate({ commit }, payload) {
			commit('SET_DEFAULT_TEMPLATE', payload);
		},
		toggleTmpltInit({ commit }) {
			commit('TOGGLE_TMPLT_INIT');
		},
	},

	getters: {
		orderState: state => state,
		IsTmpltInit: state => state.isTmpltInit,
	},
};

export default home;
